import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { MessageCircle, Facebook, ExternalLink, Gift, Star, Users } from 'lucide-react';

const WHATSAPP_GROUP = "https://chat.whatsapp.com/FASs6nHFVdd60zp6w4XkM1?mode=gi_t";
const FACEBOOK_GROUP = "https://www.facebook.com/share/g/1BqJUUvUDu/";

export default function StickersPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-slate-100 pb-24">
      {/* Header */}
      <div className="bg-gradient-to-r from-pink-500 to-orange-500 text-white p-6">
        <div className="max-w-lg mx-auto text-center">
          <div className="text-6xl mb-4">🎨</div>
          <h1 className="text-2xl font-bold mb-2">Stickers y Dinámicas</h1>
          <p className="text-pink-100">
            ¡Participa en nuestras actividades diarias y gana premios!
          </p>
        </div>
      </div>

      <div className="max-w-lg mx-auto p-4 space-y-6">
        {/* Info Card */}
        <Card className="bg-gradient-to-br from-purple-50 to-pink-50 border-2 border-purple-200">
          <CardContent className="p-6 text-center">
            <Gift className="w-12 h-12 mx-auto mb-4 text-purple-600" />
            <h2 className="text-xl font-bold text-purple-800 mb-3">
              ¡Participa y Gana!
            </h2>
            <p className="text-purple-700 leading-relaxed">
              Participa en nuestras dinámicas diarias y accede a sorteos y premios.
              Únete a nuestros grupos oficiales para mantenerte activo.
            </p>
          </CardContent>
        </Card>

        {/* How it works */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Star className="w-5 h-5 text-amber-500" />
              ¿Cómo funciona?
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-start gap-3 p-3 bg-slate-50 rounded-lg">
              <span className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center font-bold">1</span>
              <div>
                <p className="font-medium">Únete a nuestros grupos</p>
                <p className="text-sm text-muted-foreground">WhatsApp y Facebook oficial de TuPrima</p>
              </div>
            </div>
            
            <div className="flex items-start gap-3 p-3 bg-slate-50 rounded-lg">
              <span className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center font-bold">2</span>
              <div>
                <p className="font-medium">Participa en dinámicas diarias</p>
                <p className="text-sm text-muted-foreground">Publicamos actividades cada día</p>
              </div>
            </div>
            
            <div className="flex items-start gap-3 p-3 bg-slate-50 rounded-lg">
              <span className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center font-bold">3</span>
              <div>
                <p className="font-medium">Gana premios</p>
                <p className="text-sm text-muted-foreground">Accede a sorteos gratuitos y más</p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Join Groups */}
        <Card className="border-2 border-emerald-200 bg-emerald-50">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-emerald-800">
              <Users className="w-5 h-5" />
              Únete a la Comunidad
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <a
              href={FACEBOOK_GROUP}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between w-full p-4 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-medium transition-colors"
              data-testid="facebook-group-btn"
            >
              <div className="flex items-center gap-3">
                <Facebook className="w-7 h-7" />
                <div className="text-left">
                  <p className="font-bold">Grupo de Facebook</p>
                  <p className="text-sm text-blue-100">Únete a la comunidad</p>
                </div>
              </div>
              <ExternalLink className="w-5 h-5" />
            </a>
            
            <a
              href={WHATSAPP_GROUP}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between w-full p-4 bg-green-500 hover:bg-green-600 text-white rounded-xl font-medium transition-colors"
              data-testid="whatsapp-group-btn"
            >
              <div className="flex items-center gap-3">
                <MessageCircle className="w-7 h-7" />
                <div className="text-left">
                  <p className="font-bold">Únete al grupo de WhatsApp</p>
                  <p className="text-sm text-green-100">Dinámicas y sorteos</p>
                </div>
              </div>
              <ExternalLink className="w-5 h-5" />
            </a>
          </CardContent>
        </Card>

        {/* Benefits */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Gift className="w-5 h-5 text-pink-500" />
              Beneficios de participar
            </CardTitle>
          </CardHeader>
          <CardContent className="grid grid-cols-2 gap-3">
            <div className="p-3 bg-amber-50 rounded-lg text-center border border-amber-200">
              <span className="text-2xl">🎁</span>
              <p className="text-sm font-medium text-amber-800 mt-1">Sorteos gratis</p>
            </div>
            <div className="p-3 bg-purple-50 rounded-lg text-center border border-purple-200">
              <span className="text-2xl">🏆</span>
              <p className="text-sm font-medium text-purple-800 mt-1">Premios diarios</p>
            </div>
            <div className="p-3 bg-blue-50 rounded-lg text-center border border-blue-200">
              <span className="text-2xl">🤝</span>
              <p className="text-sm font-medium text-blue-800 mt-1">Comunidad activa</p>
            </div>
            <div className="p-3 bg-green-50 rounded-lg text-center border border-green-200">
              <span className="text-2xl">📢</span>
              <p className="text-sm font-medium text-green-800 mt-1">Info exclusiva</p>
            </div>
          </CardContent>
        </Card>

        {/* Footer text */}
        <p className="text-center text-sm text-muted-foreground">
          Mantente activo en nuestros grupos para no perderte ninguna dinámica
        </p>
      </div>
    </div>
  );
}
